// utility.js
const MonthConvert_year = (string) =>{
  const monthMap = {
    '01': 'Januari',
    '02': 'Februari',
    '03': 'Maret',
    '04': 'April',
    '05': 'Mei',
    '06': 'Juni',
    '07': 'Juli',
    '08': 'Agustus',
    '09': 'September',
    '10': 'Oktober',
    '11': 'November',
    '12': 'Desember'
  };
    var [year,month, day] = string.split('-');
    string =  day+' . '+monthMap[month]+' . '+year
    return string
}

const MonthConvert = (string) =>{
  const monthMap = {
    '01': 'Januari',
    '02': 'Februari',
    '03': 'Maret',
    '04': 'April',
    '05': 'Mei',
    '06': 'Juni',
    '07': 'Juli',
    '08': 'Agustus',
    '09': 'September',
    '10': 'Oktober',
    '11': 'November',
    '12': 'Desember'
  };
    var [month, day] = string.split('-');
    string =  day+'. '+monthMap[month]
    return string
}

export { MonthConvert, MonthConvert_year }